import { render, staticRenderFns } from "./createClaimWorkflow.vue?vue&type=template&id=5bade26c&scoped=true"
import script from "./createClaimWorkflow.vue?vue&type=script&lang=js"
export * from "./createClaimWorkflow.vue?vue&type=script&lang=js"
import style0 from "./createClaimWorkflow.vue?vue&type=style&index=0&id=5bade26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bade26c",
  null
  
)

export default component.exports